import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Card, CardTitle, Text } from '@reveni-io/reveni-ui'

import CustomerDetailInfo from '@/common/components/CustomerDetailInfo/CustomerDetailInfo.jsx'

import { getCustomerProfile, getCustomerTaxCodeLabel } from './helpers.js'
import * as Styles from './styles.js'

const CustomerDetailCard = ({ customerProfile, email, address, customerTaxCodes }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Datos del cliente')}</CardTitle>
      <Styles.Container>
        <CustomerDetailInfo
          nameLabel="Nombre cliente"
          customerProfile={getCustomerProfile({ customerProfile, email, address })}
          address={address}
        />
        {customerTaxCodes.map((customerTaxCode, index) => (
          <Styles.TaxCode key={`${customerTaxCode.type}-${customerTaxCode.country_code}-${index}`}>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {getCustomerTaxCodeLabel(customerTaxCode, t)}
            </Text>
            <Text type="bodyMRegular">{customerTaxCode.value}</Text>
          </Styles.TaxCode>
        ))}
      </Styles.Container>
    </Card>
  )
}

export default CustomerDetailCard
